<template>
  <DiagnosisCard
    heading="世帯年収"
    :rank="rank"
    annotation="&nbsp;"
    :text="text"
  >
    <template #content>
      <DiagnosisCardContent>
        <template #item>
          <p :class="$style.text">
            お客様 :
            <span :class="$style.text__amount">{{ userValueString }}</span>
          </p>
        </template>
      </DiagnosisCardContent>
    </template>
  </DiagnosisCard>
</template>

<script setup lang="ts">
import DiagnosisCard from '@/components/molecules/DiagnosisCard.vue'
import DiagnosisCardContent from '@/components/molecules/DiagnosisCardContent.vue'

defineProps<{
  rank: string
  userValueString: string
  text: string
}>()
</script>

<style lang="scss" module>
.text {
  font-size: 12px;
  font-weight: bold;

  &__amount {
    font-size: 16px;
  }
}
</style>
